import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { CASE_STUDIES } from "../data/content";
import { FadeUp } from "../components/Motion";
const Field = ({ label, children }) => (
  <div>
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-nexa-red">{label}</p>
    <p className="mt-3 text-sm leading-relaxed text-nexa-bone/65 md:text-base">{children}</p>
  </div>
);

const CaseStudies = () => (
  <>
    <PageHeader
      tag="Case studies — Deep cuts"
      title={
        <>
          Three fights,
          <br />
          <span className="text-nexa-red">in full.</span>
        </>
      }
      sub="Not a grid of logos. The brief, the thinking and the aftermath — exactly as they happened at Myndroot, the agency Nexa Studio was born from."
    />

    <section className="mx-auto max-w-[1600px] px-5 py-24 md:px-10" data-testid="case-study-list">
      {CASE_STUDIES.map((cs, i) => (
        <FadeUp key={cs.client}>
          <article
            className={`grid gap-10 py-16 md:grid-cols-12 ${i !== 0 ? "border-t border-white/10" : ""}`}
            data-testid={`case-study-${cs.client.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <div className="md:col-span-3">
              <span className="font-display text-7xl leading-none text-nexa-red">{cs.num}</span>
              <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-nexa-bone/50">
                {cs.sector} · {cs.year}
              </p>
              <h2 className="mt-2 font-display text-3xl uppercase leading-tight text-nexa-bone">{cs.client}</h2>
            </div>
            <div className="md:col-span-9">
              <h3 className="max-w-3xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-nexa-bone md:text-6xl">
                {cs.title}
              </h3>
              {cs.img && (
                <div className="relative mt-8 overflow-hidden border border-white/10">
                  <img src={cs.img} alt={cs.client} loading="lazy" className="h-72 w-full object-cover grayscale-[30%] md:h-96" />
                </div>
              )}
              <div className="mt-8 grid gap-8 md:grid-cols-3">
                <Field label="The brief">{cs.challenge}</Field>
                <Field label="The move">{cs.approach}</Field>
                <Field label="The aftermath">{cs.outcome}</Field>
              </div>
              <ul className="mt-8 flex flex-wrap gap-3">
                {cs.deliverables.map((d) => (
                  <li key={d} className="border border-white/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-nexa-bone/60">
                    {d}
                  </li>
                ))}
              </ul>
            </div>
          </article>
        </FadeUp>
      ))}
    </section>

    <section className="relative overflow-hidden bg-nexa-red" data-testid="case-study-cta">
      <div className="noise-overlay" />
      <div className="mx-auto max-w-[1600px] px-5 py-20 md:px-10 md:py-28">
        <FadeUp>
          <h2 className="font-display text-4xl uppercase leading-[0.95] text-white sm:text-5xl lg:text-7xl">
            The fourth one is unwritten.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
            Bring us a market to guard and a number to move. We will bring the teeth.
          </p>
          <Link
            to="/contact"
            data-testid="case-study-cta-button"
            className="group mt-8 inline-flex items-center gap-3 bg-nexa-black px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] text-white transition-transform duration-200 hover:-translate-y-1 hover:bg-white hover:text-nexa-black"
          >
            Write it with us <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </div>
    </section>
  </>
);

export default CaseStudies;
